import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (object, { getState, rejectWithValue }) => {

    try {
      const { data } = await axios.get(
        "https://fakestoreapi.com/products"
      );
      return data;
    } catch (error) {
      rejectWithValue(error.response);
    }


  }
);
